import Vue from 'vue'
import Vuex from 'vuex'
import { Tooltip } from 'bootstrap'
import { image } from '@/http/api/image.js'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    // 元件狀態
    isLoading: false,
    isAlerting: false,
    isHideNav: false,
    isShowDeleteModal: false,
    isShowKeywordsModal: false,

    // 元件資訊
    bootstrap_tooltip: null,
    alerts: {
      state: null,
      icon: null,
      title: null,
      info: null
    },

    // dateTable 頁面控管
    perPage: 10,
    totalRows: 0,

    // 後端回傳錯誤訊息
    errMsg: null,
    errMsgKey: null,

    // 權限資訊
    token: {
      headers: {
        Authorization: null
      }
    },
    userInfo: null,

    // 螢幕寬度判斷
    windowWidth: 0,
    viewport: '', // bootstrap 5 breakpoints
    breakpoints: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
      xxl: 1400
    },

    // 判斷客戶
    client: process.env.VUE_APP_API_CLIENT,
    locationHost: window.location.host,
    clientInfo: [
      {
        id: 'furniture',
        name: '芳林家居',
        testDomain: 'component-module-admin.susan-dev.200ok.tw',
        domain: 'console.fanglincasa.com'
      },
      {
        id: 'acadiatravel',
        name: '燕府旅遊',
        testDomain: 'travel-admin.susan-dev.200ok.tw',
        domain: 'console.acadiatravel.com.tw'
      }
    ],

    // nav list
    routerName: null,
    navList: {
      furniture: [
        {
          title: '基本設定',
          navList: [
            {
              routerName: 'Website',
              name: '網站資訊',
              icon: 'bi bi-window'
            },
            {
              routerName: 'ContactInfo',
              name: '聯絡資訊',
              icon: 'bi bi-telephone'
            }
          ]
        },
        {
          title: '版面管理',
          navList: [
            {
              routerName: 'NavbarInfo',
              name: '導覽列',
              icon: 'bi bi-signpost-split'
            },
            {
              routerName: 'HomeInfo',
              name: '首頁',
              icon: 'bi bi-house'
            },
            {
              routerName: 'About',
              name: '關於我們',
              icon: 'bi bi-people'
            },
            {
              routerName: 'Policy',
              name: '關於法律與隱私',
              icon: 'bi bi-vector-pen'
            }
          ]
        },
        {
          title: '產品管理',
          navList: [
            {
              routerName: 'ProductCategory',
              name: '分類設定',
              icon: 'bi bi-folder'
            },
            {
              routerName: 'Product',
              name: '產品列表',
              icon: 'bi bi-handbag'
            }
          ]
        },
        {
          title: '訂單管理',
          navList: [
            {
              routerName: 'Order',
              name: '訂單列表',
              icon: 'bi bi-cart-check'
            },
            {
              routerName: 'Report',
              name: '報表匯出',
              icon: 'bi bi-clipboard-check'
            },
            {
              routerName: 'Notice',
              name: '其他設定',
              icon: 'bi bi-exclamation-circle'
            }
          ]
        },
        {
          title: '文章管理',
          navList: [
            {
              routerName: 'ArticleCategory',
              name: '分類設定',
              icon: 'bi bi-folder'
            },
            {
              routerName: 'Article',
              name: '文章列表',
              icon: 'bi bi-file-richtext'
            }
          ]
        },
        {
          title: '諮詢列表',
          navList: [
            {
              routerName: 'InquiryProduct',
              name: '訂製商品諮詢單',
              icon: 'bi bi-clipboard-check'
            },
            {
              routerName: 'InquiryStore',
              name: '門市參觀諮詢單',
              icon: 'bi bi-clipboard-check'
            }
          ]
        },
        {
          title: '其他',
          navList: [
            {
              routerName: 'Store',
              name: '門市管理',
              icon: 'bi bi-shop'
            },
            {
              routerName: 'User',
              name: '使用者管理',
              icon: 'bi bi-person'
            }
          ]
        }
      ],
      acadiatravel: [
        {
          title: '基本設定',
          navList: [
            {
              routerName: 'Website',
              name: '網站資訊',
              icon: 'bi bi-window'
            },
            {
              routerName: 'ContactInfo',
              name: '聯絡資訊',
              icon: 'bi bi-telephone'
            }
          ]
        },
        {
          title: '版面管理',
          navList: [
            {
              routerName: 'NavbarInfo',
              name: '導覽列',
              icon: 'bi bi-signpost-split'
            },
            {
              routerName: 'HomeInfo',
              name: '首頁',
              icon: 'bi bi-house'
            },
            {
              routerName: 'About',
              name: '關於我們',
              icon: 'bi bi-people'
            }
          ]
        },
        {
          title: '旅遊行程管理',
          navList: [
            {
              routerName: 'TravelCategory',
              name: '分類設定',
              icon: 'bi bi-folder'
            },
            {
              routerName: 'Travel',
              name: '行程列表',
              icon: 'bi bi-geo'
            }
          ]
        },
        {
          title: '文章管理',
          navList: [
            {
              routerName: 'ArticleCategory',
              name: '分類設定',
              icon: 'bi bi-folder'
            },
            {
              routerName: 'Article',
              name: '文章列表',
              icon: 'bi bi-file-richtext'
            }
          ]
        },
        {
          title: '諮詢列表',
          navList: [
            {
              routerName: 'InquiryItinerary',
              name: '旅遊行程諮詢單',
              icon: 'bi bi-clipboard-check'
            }
          ]
        },
        {
          title: '其他',
          navList: [
            {
              routerName: 'User',
              name: '使用者管理',
              icon: 'bi bi-person'
            }
          ]
        }
      ]
    }
  },
  getters: {
    clientName: (state) => {
      let clientName = ''
      state.clientInfo.forEach((item) => {
        if (item.id === state.client) {
          // 本地
          clientName = item.name
        }

        if (
          process.env.VUE_APP_API_CLIENT === 'CodingTest' &&
          item.testDomain === state.locationHost
        ) {
          // susan-dev 測試環境
          clientName = item.name
        }
        if (
          process.env.NODE_ENV === 'production' &&
          item.domain === state.locationHost
        ) {
          // 正式或客戶端測試環境
          clientName = item.name
        }
      })
      return clientName
    },
    clientId: (state) => {
      let clientId = ''
      state.clientInfo.forEach((item) => {
        if (item.id === state.client) {
          // 本地
          clientId = item.id
        }

        if (
          process.env.VUE_APP_API_CLIENT === 'CodingTest' &&
          item.testDomain === state.locationHost
        ) {
          // susan-dev 測試環境
          clientId = item.id
        }
        if (
          process.env.NODE_ENV === 'production' &&
          item.domain === state.locationHost
        ) {
          // 正式或客戶端測試環境
          clientId = item.id
        }
      })
      return clientId
    },
    errMsgInfo: (state) => {
      if (!state.errMsg) return null
      const newArray = []
      Object.keys(state.errMsg).forEach((key) => {
        newArray.push(`${state.errMsgKey[key] || key}：${state.errMsg[key]}`)
      })
      return JSON.stringify(newArray, null, ' ').replace(/\[|]|"/g, ' ')
    },
    pageName: (state, getters) => {
      if (!getters.clientId) return null
      let pageName = null
      state.navList[getters.clientId].forEach((item) => {
        item.navList.forEach((nav) => {
          if (nav.routerName === state.routerName) {
            pageName = nav.name
          }
        })
      })
      return pageName
    },
    breadcrumb: (state, getters) => {
      if (!getters.clientId) return null
      let breadcrumb = null
      state.navList[getters.clientId].forEach((item) => {
        item.navList.forEach((nav) => {
          if (nav.routerName === state.routerName) {
            breadcrumb = [item.title, nav.name]
          }
        })
      })
      return breadcrumb
    }
  },
  mutations: {
    InitBootstrapTooltip (state) {
      if (state.bootstrap_tooltip && state.bootstrap_tooltip.length) {
        state.bootstrap_tooltip.forEach((tooltip) => {
          tooltip.hide()
        })
      }
      state.bootstrap_tooltip = [].slice
        .call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        .map(
          (tooltipTriggerEl) =>
            new Tooltip(tooltipTriggerEl, { trigger: 'hover' })
        )
    },
    Loading (state) {
      state.isLoading = true
    },
    Loaded (state) {
      state.isLoading = false
    },
    Alerted (state) {
      state.isAlerting = true
    },
    AlertedClose (state) {
      state.isAlerting = false
    },
    HidingNav (state) {
      state.isHideNav = true
    },
    HidedNav (state) {
      state.isHideNav = !state.isHideNav
    },
    AlertsInfo (state, data) {
      state.alerts.state = data.state
      state.alerts.icon = data.icon
      state.alerts.title = data.title
      state.alerts.info = data.info
    },
    GetViewport (state) {
      const pseudoElementStyleContent = getComputedStyle(
        document.querySelector('body'),
        ':after'
      ).content
      // eslint-disable-next-line no-useless-escape
      state.viewport = pseudoElementStyleContent.replace(/\"/g, '')
    },
    GetToken (state) {
      state.token.headers.Authorization = `Bearer ${localStorage.getItem(
        'codingIt_admin_token'
      )}`
    },
    SetWindowWidth (state, value) {
      state.windowWidth = value
    },
    SetErrMsg (state, data) {
      state.errMsg = data
      setTimeout(() => {
        state.errMsg = null
      }, 10000)
    },
    SetErrMsgKey (state, data) {
      state.errMsgKey = data
    },
    ClearErrMsg (state) {
      state.errMsg = null
    },
    SetRouterName (state, data) {
      state.routerName = data
    },
    SetTotalRows (state, data) {
      state.totalRows = data
    },
    ToggleDeleteModal (state, data) {
      state.isShowDeleteModal = data
    },
    ToggleKeywordsModal (state, data) {
      state.isShowKeywordsModal = data
    }
  },
  actions: {
    uploadImage ({ commit, state, getters }, imageFileEle) {
      return new Promise((resolve) => {
        const files = new FormData()
        const config = JSON.parse(JSON.stringify(state.token))

        files.append('image', imageFileEle.files[0])
        config.headers['Content-Type'] = imageFileEle.files[0].type

        if (!files) return

        commit('Loading')

        image
          .update(files, config)
          .then((res) => {
            const { data } = res
            if (res.status <= 201) {
              resolve((process.env.VUE_APP_API_BASE_URL || '') + data.path)
              commit('AlertsInfo', {
                state: 'success',
                title: '成功',
                info: '上傳圖片成功'
              })
            } else {
              commit('SetErrMsg', data.errMsg)
              commit('AlertsInfo', {
                state: 'error',
                title: '失敗 ' + res.status,
                info: getters.errMsgInfo
              })
            }
            commit('Alerted')
            commit('Loaded')
          })
          .catch((err) => {
            commit('SetErrMsg', err)
            commit('AlertsInfo', {
              state: 'error',
              title: '失敗',
              info: getters.errMsgInfo
            })
            commit('Alerted')
            commit('Loaded')
          })
      })
    }
  },
  modules: {}
})
